import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Messages } from 'primereact/messages';
import { useRef } from 'react';
import autenticacaoService from '../services/autenticacaoService';
import { hideProcessing, showProcessing } from '../utils/utils';

const RecuperarSenhaDialog = ({ visible, onHide }) => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [etapa, setEtapa] = useState(1); // 1: solicitar email, 2: confirmar
    const msgRef = useRef();

    const handleClose = () => {
        setEmail('');
        setEtapa(1);
        onHide();
    };

    const handleSolicitarRecuperacao = async () => {
        if (!email || email.trim() === '') {
            msgRef.current.show({
                closable: false,
                severity: 'warn',
                summary: 'Aviso',
                detail: 'Por favor, digite seu email',
            });
            return;
        }

        setLoading(true);
        showProcessing();

        try {
            const response = await autenticacaoService.recuperarSenha(email);

            if (response.status === 200) {
                msgRef.current.show({
                    closable: false,
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: 'Email de recuperação enviado com sucesso! Verifique sua caixa de entrada.',
                });

                setTimeout(() => {
                    hideProcessing();
                    setLoading(false);
                    handleClose();
                }, 2000);
            }
        } catch (error) {
            hideProcessing();
            setLoading(false);

            msgRef.current.show({
                closable: false,
                severity: 'error',
                summary: 'Erro',
                detail: error.response?.data || 'Erro ao solicitar recuperação de senha',
            });
        }
    };

    const dialogFooter = (
        <div>
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={handleClose}
                className="p-button-text"
                disabled={loading}
            />
            <Button
                label="Enviar Email"
                icon="pi pi-check"
                onClick={handleSolicitarRecuperacao}
                loading={loading}
            />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            style={{ width: '90vw', maxWidth: '450px' }}
            header="Recuperar Senha"
            modal
            className="p-fluid"
            footer={dialogFooter}
            onHide={handleClose}
        >
            <Messages ref={msgRef} style={{ width: '100%', marginBottom: '1rem' }} />

            <div className="field">
                <label htmlFor="email" className="block mb-2 font-semibold">
                    Email *
                </label>
                <p className="text-sm mb-4">
                    Digite o email associado à sua conta. Você receberá um link para redefinir sua senha.
                </p>
                <InputText
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    disabled={loading}
                    placeholder="seu.email@example.com"
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            handleSolicitarRecuperacao();
                        }
                    }}
                />
            </div>
        </Dialog>
    );
};

export default RecuperarSenhaDialog;
